import React from "react";
import classNames from "classnames";
import { Button } from "reactstrap";

import { Loading } from "../../components/Icons";

export default props => {
  const { children, className, loading, loadingContent, loadingColor, disabled, icon, ...rest } = props
  return (
    <Button className={classNames(className, {'has-icon':icon})} disabled={loading || disabled} {...rest}>
      {loading && (loadingContent || <Loading width="24" height="24" />)}
      {!loading && icon}
      {!loading && children}
    </Button>
  )
}